import { AUTHORIZE_ENDPOINT, KEYCLOAK_CLIENT_ID, KEYCLOAK_SCOPE } from './config';

type TAuthorizeOptions = {
	state: string;
	redirectUri: string;
	codeChallenge?: string | null;
	silent?: boolean;
};

export const buildAuthorizeUrl = ({
	state,
	redirectUri,
	codeChallenge,
	silent,
}: TAuthorizeOptions): string => {
	const params = new URLSearchParams({
		response_type: 'code',
		client_id: KEYCLOAK_CLIENT_ID,
		redirect_uri: redirectUri,
		state,
	});

	if (KEYCLOAK_SCOPE) params.set('scope', KEYCLOAK_SCOPE);
	if (silent) params.set('prompt', 'none');
	if (codeChallenge) {
		params.set('code_challenge', codeChallenge);
		params.set('code_challenge_method', 'S256');
	}

	return `${AUTHORIZE_ENDPOINT}?${params.toString()}`;
};
